import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { ColorOptionLabel, MiDetailFields } from "@miplatform/components";
import { CONFIGURABLE_COLORS, INPUT_TYPES } from "@miplatform/constants";
import { IInspectionTemplatePayload } from "@miplatform/types";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";

export const InspectionTemplateDetailsTab: FC<
  InspectionTemplateDetailsTabViewProps
> = ({ form, extraTabProps }) => {
  const { control } = form;
  const inspectionTemplateDetailFields = [
    {
      label: "Inspection Name",
      name: "name",
      formControl: control,
      required: true,
    },
    {
      label: "Abbreviation",
      name: "abbreviation",
      formControl: control,
      required: true,
    },
    {
      label: "Color",
      name: "color",
      fieldType: INPUT_TYPES.SELECT,
      formControl: control,
      options: CONFIGURABLE_COLORS.map(({ color, label }) => ({
        label: <ColorOptionLabel label={label} color={color} />,
        value: color,
      })),
      required: true,
    },
    {
      label: "Description",
      name: "description",
      formControl: control,
    },
  ];

  const aiRedTagFields = [
    {
      label: "Allow for AI Red Tag",
      name: "allowAiRedTag",
      formControl: control,
      fieldType: INPUT_TYPES.SWITCH,
    },
  ];
  return (
    <>
      <ConfigAccordionHeader title="Inspection Type Details">
        <MiDetailFields detailFields={inspectionTemplateDetailFields} />
      </ConfigAccordionHeader>
      <ConfigAccordionHeader title="Red Tagging">
        <MiDetailFields detailFields={aiRedTagFields} />
      </ConfigAccordionHeader>
    </>
  );
};

interface InspectionTemplateDetailsTabViewProps {
  form: UseFormReturn<IInspectionTemplatePayload>;
  extraTabProps?: {
    isReadOnly?: boolean;
  };
}
